import styled from 'styled-components';
import Table from 'rc-table';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import React from 'react';
import {
  selectInvoiceFilter,
  selectInvoices,
  selectLatestProductInvoice,
  selectVehicleInvoices,
} from '../../Invoices/selectors';
import { InvoiceListItem } from '../../Invoices/components/InvoiceListItem';
import { InvoiceEmailStatus } from '../../Invoices/components/InvoiceEmailStatus';
import { getDate } from '../../Vehicles/helpers';
import { ViesLabel } from '../../Companies/components/ViesLabel';
import { KanbanProgressBar } from '../../KanbanBoards/components/ProgressBar';
import { formatCurrency, formatLicensePlate } from '../../../utils/string';
import { BaseComponent } from '../../../components/BaseComponent';
import {
  changeInvoiceFilter,
  fetchLatestProductInvoice,
  fetchProductInvoices,
  fetchVehicleInvoices,
} from '../../Invoices/actions';
import { selectWork, selectWorks } from '../../Api/selectors';
import {
  INVOICE_DIRECTIONS,
  REQUEST_INVOICES,
  REQUEST_LAST_PRODUCT_INVOICE_ID,
  REQUEST_PRODUCT_INVOICES,
} from '../../Invoices/constants';
import { ProductInvoiceCreateModals } from '../pages/productInvoices/create';
import { fetchVehicle } from '../../Vehicles/actions';
import { REQUEST_VEHICLE } from '../../Vehicles/constants';
import { selectVehicle } from '../../Vehicles/selectors';
import { ProductInvoicesTable } from './ProductInvoiceTable';
import { Loader } from '../../../components/Loader';
import { VBox } from '../../../components/Box';
import { Dropdown } from '../../../components/Dropdown';
import { InvoicesOverview } from '../../Invoices/pages/overview';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { Modal } from '../../../components/Modal';
import { selectProductInvoices } from '../../Invoices/selectors';
import { Button } from '../../../components/Buttons';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const Container = styled.div`
  width: 100%;
  background: white;
  padding: 20px;
  h3 {
    font-size: 20px;
    font-weight: 500;
  }
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

const DescriptionCell = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 200px;
  justify-content: center;
`;

const PaidWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const IconWrapper = styled.div`
  color: ${props => (props?.color === 'green' ? '#11ab79' : props?.color === 'orange' ? '#FC9629' : '#d50046')};
`;

const ActionsContainer = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const VEHICLE_INCOMING_TYPE = 'vehicle incoming';

/* eslint-disable react/prefer-stateless-function */
class ProductInvoicesOverviewTableComp extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOptionModal: false,
      closeOptionalModal: true,
    };
  }

  componentDidMount() {
    this.props.fetchVehicle();
    this.props.fetchVehicleInvoices();
    this.props.fetchLatestProductInvoice();
  }

  get invoices() {
    return this.props.invoices;
  }

  get vehicle() {
    return this.props.vehicle;
  }

  formatDate = dateString => {
    if (!dateString) return '-';
    return dayjs(dateString).format('DD-MM-YYYY');
  };

  to(url, newWindow) {
    //
    if (newWindow) {
      window.open(url);
    } else {
      this.props.history.push(url);
    }
  }

  tofn(url) {
    return event => {
      this.to(url, event?.ctrlKey || event?.metaKey);
    };
  }

  onChangeDirection(pair) {
    const direction = pair.value;
    this.setState({ direction }, () => this.props.fetch(direction));
  }
  directionModal() {
    const vals = Object.values(INVOICE_DIRECTIONS);

    const options = vals.map(val => ({
      label: this.lbl(`invoice.direction.${this.props.type}.${val}`),
      value: val,
    }));

    const value = options.find(o => o.value == this.state.direction);
    return (
      <ModalComponent onClose={this.tofn(`/vehicles/${this.props.match?.params?.vehicleId}`)}>
        {this.state.isOptionModal ? (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <b>{this.lbl('invoice.filter.massage')}</b>
            &nbsp; &nbsp;
            <b>{this.props?.vehicleInvoices?.[0]?.invoiceSubjects?.[0]?.description}</b>
            &nbsp; &nbsp;
            <div style={{ flexDirection: 'row' }}>
              <ButtonComponent
                style={'ButtonSoftEdit'}
                size={'btn-sm'}
                onClick={() =>
                  this.to(
                    `/invoices/product-invoices/vehicle/${this.props.match?.params?.vehicleId}/invoice/${this.props.latestProductInvoice}`,
                  )
                }
              >
                {this.lbl('invoice.filter.yes')}
              </ButtonComponent>
              <ButtonComponent
                style={'ButtonSoftEdit'}
                size={'btn-sm'}
                onClick={() =>
                  this.setState({
                    isOptionModal: false,
                    closeOptionalModal: false,
                  })
                }
              >
                {this.lbl('invoice.filter.no')}
              </ButtonComponent>
            </div>
          </div>
        ) : (
          <SearchSelect
            placeholder={'Select direction'}
            options={options}
            value={value}
            onChange={pair => {
              this.to(`/invoices/product-invoices/vehicle/${this.props.vehicle?.id}/product/${pair.value}/create`);
            }}
            minWidth={'100%'}
          />
        )}
      </ModalComponent>
    );
  }

  notFinalFilter(invoice) {
    return invoice.finalizationStatus !== 'DONE';
  }
  finalFilter(invoice) {
    return invoice.finalizationStatus === 'DONE';
  }

  renderContent() {
    // if (!this.state.direction) return <p>Please select direction</p>;

    return (
      <>
        {/* <ProductInvoicesTable
            key={'draft'}
            header="Draft"
            invoices={this.invoices.filter(this.notFinalFilter)}
            direction={this.props.direction}
            vehicleId={this.vehicle?.id}
          /> */}
        <InvoicesOverview vehiclePage vehicleId={this.props.vehicleId} vehicle={this.vehicle} />
        {/* <ProductInvoiceCreateModals direction={this.state.direction} vehicleId={this.vehicle?.id} /> */}

        {/* <ProductInvoicesTable
          key={'final'}
          header="Final"
          invoices={this.invoices.filter(this.finalFilter)}
          direction={this.props.direction}
          vehicleId={this.vehicle?.id}
        /> */}
      </>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;
    const filteredArray = this.props.vehicleInvoices?.filter(
      item => item.finalizationStatus === null && item.subjectType === 'product',
    );
    if (filteredArray.length >= 1 && this.state.closeOptionalModal) {
      this.setState({ isOptionModal: true });
    }
    return (
      <Container>
        <VBox style={{ marginBottom: '30px' }}>
          <h3>
            Vehicle: {this.vehicle?.id} {formatLicensePlate(this.vehicle?.regplate)}
          </h3>
          {!this.props.filter?.direction && this.directionModal()}
        </VBox>
        {/* {this.renderContent()} */}
      </Container>
    );
  }
}

ProductInvoicesOverviewTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoices: selectInvoices(),
    vehicleInvoices: selectVehicleInvoices(),
    productInvoices: selectProductInvoices(),
    latestProductInvoice: selectLatestProductInvoice(),
    vehicle: selectVehicle(ownProps.vehicleId),
    work: selectWorks([REQUEST_PRODUCT_INVOICES, REQUEST_VEHICLE, REQUEST_LAST_PRODUCT_INVOICE_ID]),
    filter: selectInvoiceFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: direction => {
      dispatch(fetchProductInvoices(ownProps.vehicleId, direction));
    },
    fetchVehicle: () => {
      dispatch(fetchVehicle(ownProps.vehicleId));
    },
    setDirection(value) {
      dispatch(changeInvoiceFilter('direction', value));
    },
    fetchVehicleInvoices() {
      dispatch(fetchVehicleInvoices(ownProps.vehicleId));
    },
    fetchLatestProductInvoice() {
      dispatch(fetchLatestProductInvoice(ownProps.vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductInvoicesOverviewTable = compose(withConnect, withRouter, injectIntl)(ProductInvoicesOverviewTableComp);
